export default __webpack_public_path__ + "static/media/add-workout.bc90e1bb.svg";